<template>
  <v-app>
    <v-app-bar app flat color="grey lighten-4">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>
    <v-navigation-drawer app v-model="drawer" overlay-opacity="0">
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar tile>
            <img
              src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>ACCUEIL RH</v-list-item-title>
            <v-list-item-subtitle>Interface de gestion</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list dense nav>
        <v-subheader>DEMANDES</v-subheader>
        <v-list-item link to="/users">
          <v-list-item-icon>
            <v-icon>mdi-inbox-full-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Utilisateurs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="mt-10">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "App",
  components: { UserProfile },
  data: () => ({
    fab: false,
    drawer: null,
  }),
  methods: {
    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/absences/export`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "requests.xlsx");
    },
  },
};
</script>

<style>
.separator {
  display: inline-block;
}
</style>